import React from "react";
import { Link } from "react-router-dom"; // <-- 1. IMPORT the Link component

// Import your local icons
import franchisingIcon from "../assets/icons/franchising.png";
import supplyingIcon from "../assets/icons/supplying.png";
import subscribingIcon from "../assets/icons/subscribing.png";
import becomeStaffIcon from "../assets/icons/becomeastaff.png";

const ServicesSection = () => {
  // --- 2. ADD a `path` property to each service object ---
  const services = [
    {
      icon: franchisingIcon,
      title: "Franchising",
      path: "/franchise", // Link to the Franchise screen
    },
    {
      icon: supplyingIcon,
      title: "Supplying",
      path: "/coming-soon", // Link to the Coming Soon screen
    },
    {
      icon: subscribingIcon,
      title: "Subscribing",
      path: "/subscription", // Link to the Coming Soon screen
    },
    {
      icon: becomeStaffIcon,
      title: "Training",
      path: "/training", // Link to the Training screen
    },
  ];

  return (
    <div className="services-container">
      {services.map((service, index) => (
        // --- 3. WRAP each `service-item` in a Link component ---
        <Link key={index} to={service.path} className="service-item-link">
          <div className="service-item">
            <div className="service-icon">
              <img src={service.icon} alt={`${service.title} icon`} />
            </div>
            <p className="service-title">{service.title}</p>
          </div>
        </Link>
      ))}
    </div>
  );
};

export default ServicesSection;
